mutation QueueDirectorySync {
    queueDirectorySync {
        success
    }
}
